import { createContext } from 'react';
import { Gender } from '@/enum';
import { FlowObject } from '@@/react-hooks';
import { CascaderOptionType } from 'antd/lib/cascader';
import { FormItemProps } from 'antd';

export interface HomeContext {
  commonFormItemProps: FormItemProps;
  categoryCascaderOptionsState: FlowObject<CascaderOptionType[]>;
  genderDesignerOptionsDictState: FlowObject<Record<Gender, string[]>>;
  labelerListState: FlowObject<string[]>;
}

export const homeContext = createContext<HomeContext>(null);
